/**
 * Run a callback when the DOM is ready.
 *
 * @param {() => void} callback
 */
export function domReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
}
